import PoweredByLogo from './PoweredByLogo';

export default PoweredByLogo;



// WEBPACK FOOTER //
// ./src/client/Components/PoweredByLogo/index.js